<template>
  <div class="violation-history-skeleton" role="status" aria-label="Đang tải lịch sử xử lý">
    <article v-for="card in 2" :key="card" class="history-skeleton-card">
      <header>
        <el-skeleton-item variant="text" class="history-skeleton-title" />
        <el-skeleton-item variant="text" class="history-skeleton-time" />
      </header>

      <div v-for="row in 7" :key="row" class="history-skeleton-row">
        <el-skeleton-item variant="text" class="history-skeleton-label" />
        <el-skeleton-item
          variant="text"
          class="history-skeleton-value"
          :class="{'history-skeleton-value--long': row === 1 || row === 4}"
        />
      </div>
    </article>
  </div>
</template>

<script>
export default {
  name: 'ViolationHistorySkeleton'
};
</script>

<style scoped lang="scss" src="./ViolationHistorySkeleton.scss"></style>
